package com.essntl.features.file.data.supabase

import com.essntl.features.file.domain.model.FileModel
import kotlinx.serialization.json.JsonArray
import kotlinx.serialization.json.JsonElement
import kotlinx.serialization.json.JsonPrimitive

internal fun FileModel.toRequestMap(): Map<String, JsonElement> {
    val requestMap = mutableMapOf<String, JsonElement>()
    requestMap["url"] = JsonPrimitive(url)

    name?.let { requestMap["name"] = JsonPrimitive(it) }

    entityType?.let { requestMap["entity_type"] = JsonPrimitive(it) }

    if (!keywords.isNullOrEmpty()) {
        requestMap["keywords"] = JsonArray(keywords!!.map { JsonPrimitive(it) })
    }

    return requestMap
}
